import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  TrailingInfo,
  TrailingSuccess,
  TrailingDanger
} from '../../atoms/icons/text-input'
import { SpinnerWhite } from '../../atoms/icons/special'

const snackbarVariantOptions = {
  STANDART: 'standart',
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  LOADING: 'loading'
}

const snackbarStyleVariantOptions = {
  [snackbarVariantOptions.STANDART]: {
    backgroundColor: colorsOptions.greys['grey-10'],
    color: colorsOptions.greys['grey-100'],
    icon: (
      <TrailingInfo size="icon-m" stroke={colorsOptions.greys['grey-100']} />
    ),
    colorCloseIcon: colorsOptions.greys['grey-100']
  },
  [snackbarVariantOptions.SUCCESS]: {
    backgroundColor: colorsOptions.semantics.success.normal,
    color: colorsOptions.greys.white,
    icon: <TrailingSuccess size="icon-m" stroke={colorsOptions.greys.white} />,
    colorCloseIcon: colorsOptions.greys.white
  },
  [snackbarVariantOptions.ERROR]: {
    backgroundColor: colorsOptions.semantics.danger.error,
    color: colorsOptions.greys.white,
    icon: <TrailingDanger size="icon-m" stroke={colorsOptions.greys.white} />,
    colorCloseIcon: colorsOptions.greys.white
  },
  [snackbarVariantOptions.INFO]: {
    backgroundColor: colorsOptions.semantics.info.normal,
    color: colorsOptions.greys.white,
    icon: <TrailingInfo size="icon-m" stroke={colorsOptions.greys.white} />,
    colorCloseIcon: colorsOptions.greys.white
  },
  [snackbarVariantOptions.LOADING]: {
    backgroundColor: colorsOptions.semantics.info.normal,
    color: colorsOptions.greys.white,
    icon: <SpinnerWhite />,
    colorCloseIcon: colorsOptions.greys.white
  }
}

export { snackbarVariantOptions, snackbarStyleVariantOptions }
